/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import EndpointsConst from "../consts/EndpointsConst";
import { getAPIUrl } from "../utilities/APIHelper";

class LifeguardService {
  /**
   * [POST]
   * Submits customer contact form
   * @param {Object} formValues
   *
   * @returns {Promise}
   */
  submitLifeguardRequest(formValues) {
    const url =
      getAPIUrl() + EndpointsConst.API.LIFEGUARD.SUBMIT_LIFEGUARD_REQUEST;
    return axios.post(url, formValues);
  }
}

export default new LifeguardService();
